import React, {useContext} from "react";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {MessageBottomContainerContext, MessageContext} from "../../../Message.tsx";
import {stopPlaying} from "../../../../../../Utils/misc/playAudio.ts";
import {addAdjacentMessage} from "../../../../../../Utils/messageObject/messageObjectUtils.ts";
import {GlobalContext} from "../../../../../../App.tsx";

interface RegenerateProps {}

const Regenerate: React.FC<RegenerateProps> = () => {
    const { handleSubmitHelper, messagesRef, currentMessageRef, messagesSequenceRef, miscMidRenderRefs, llmRequestRefs } = useContext(GlobalContext);
    const { isPreview } = useContext(MessageContext);
    const { group } = useContext(MessageBottomContainerContext);
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { canSubmit } = dynamicStateObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleRegenerateClick = () => {
        if (!canSubmit) return;

        if (miscMidRenderRefs.current.playingId && group.index <= miscMidRenderRefs.current.playingId) {
            stopPlaying(setDynamicStateObj, miscMidRenderRefs);
        }

        addAdjacentMessage(
            group.messages[0].message.content.filter((item: any) => (!item.removeOnRegenerate && item.type !== "text") || (item.type === "text" && item.text.trim() !== "")),
            group.index,
            messagesRef,
            currentMessageRef,
            messagesSequenceRef,
            llmRequestRefs
        );

        handleSubmitHelper();
        setDynamicStateObj({editingId: null});
    };

    return (
        <button
            className={`h-5 w-5 mr-2.5 ${!canSubmit || isPreview ? "opacity-30 cursor-default" : ""}`}
            onClick={handleRegenerateClick}
            disabled={isPreview}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                className={`w-full h-full ${theme === 'dark' ? 'stroke-neutral-200' : 'stroke-neutral-800'} ${isPreview ? 'filter grayscale' : ''}`}
                strokeWidth="2"
            >
                <path d="M20 11A8 8 0 0 0 4.5 9M4 5v4h4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 13a8 8 0 0 0 15.5 2m.5 4v-4h-4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    )
}

export default Regenerate;